import { SxProps, Theme } from "@mui/material";

export const containerStyle: SxProps<Theme> = {
  display: "flex",
  flexDirection: { xs: "column", sm: "column", md: "row" },
  borderRadius: 2,
  gap: "24px",
  px: { xs: 1, sm: 2, md: 10 },
};

export const leftBoxStyle: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  alignItems: { xs: "center", sm: "center", md: "flex-start" },
  justifyContent: "center",
  gap: 0.25,
  minWidth: 0,
  maxWidth: { xs: "100%", md: "360px" },
};

export const titleStyle: SxProps<Theme> = (theme) => ({
  fontSize: "20px",
  fontWeight: 600,
  color: theme.palette.quizPopap.quizText,
});

export const contestTitleStyle: SxProps<Theme> = (theme) => ({
  fontSize: { xs: "13px", sm: "14px" },
  fontWeight: 500,
  lineHeight: 1.3,
  color: theme.palette.quizPopap.quizText,
  opacity: 0.72,
  maxWidth: "100%",
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  textAlign: { xs: "center", md: "left" },
});

export const progressContainerStyle: SxProps<Theme> = {
  display: "flex",
  flexDirection: "column",
  flex: 1,
  mx: { xs: "0", sm: "0", md: "40px" },
  justifyContent: "center",
};

export const progressRowStyle: SxProps<Theme> = {
  display: "flex",
  justifyContent: "space-between",
};

export const progressLabelStyle: SxProps<Theme> = {
  color: "#06B6D4",
  fontSize: "16px",
  fontWeight: 600,
};

export const linearProgressContainerStyle: SxProps<Theme> = {
  width: "100%",
};

export const linearProgressStyle: SxProps<Theme> = (theme) => ({
  height: 10,
  borderRadius: 4,
  backgroundColor: theme.palette.quizPopap.quizLineBg,
  "& .MuiLinearProgress-bar": {
    background: "linear-gradient(90deg, #8957CF 0%, #28C9DC 100%)",
  },
});
